module.exports = __webpack_public_path__ + "media/images/bg/mosaic/cloud-red-d9e32e86e2f2ac53b7efe65acac8dab7.svg";